import "whatwg-fetch";
import { hasExpired } from "../../helpers/User";
import actionTypes from "../actionTypes";

/**
 * Start a fetch() request with auth headers through a redux action
 * - type: API_FETCH
 * - start[optional]: dispatches this first with payload
 * - payload[optional]: for start action
 * - receive[optional]: dispatches this on successful response with response payload, default API_SUCCESS
 * - url: see whatwg-fetch
 * - options: see whatwg-fetch
 *
 * @param action
 */
export default ({ dispatch, getState }) => next => action => {
  if (action.type !== actionTypes.app.API_FETCH) {
    return next(action);
  }

  const { auth } = getState();

  const response = next(action);

  if (action.start) {
    dispatch(apiStart(action));
  }

  if (hasExpired(auth)) {
    dispatch(apiInvalidAccessToken());
  }

  const options = addTokenToOptions(action.options, auth.token);

  try {
    theFetch(action.url, options).then(response => {
      if (response.ok) {
        dispatch(apiSuccess(action.receive, response.json));
      } else {
        dispatch(apiUnsuccessful(response));
      }
    });
  } catch (error) {
    dispatch(apiFailure(error));
  }

  return response;
};

const theFetch = (url, options = {}) => {
  return fetch(url, options).then(response => {
    return response.json().then(json => ({
      json,
      ok: response.ok,
      status: response.status,
      statusText: response.statusText
    }));
  });
};

const addTokenToOptions = (fetchOptions, token) => {
  const options = Object.assign({}, fetchOptions, {});

  return Object.assign({}, options, {
    headers: Object.assign({}, options.headers, {
      Accept: "application/json",
      Authorization: "Bearer " + token,
      "Content-Type": "application/json"
    })
  });
};

const apiSuccess = (type = actionTypes.app.API_SUCCESS, data) => ({
  payload: data,
  type
});

const apiFailure = error => ({
  type: actionTypes.app.errors.API_FAILURE,
  error
});

const apiUnsuccessful = response => ({
  type: actionTypes.app.errors.API_UNSUCCESSFUL,
  response
});

const apiStart = action => ({
  type: action.start,
  payload: action.payload
});

const apiInvalidAccessToken = () => ({
  type: actionTypes.app.errors.API_INVALID_ACCESS_TOKEN
});



// WEBPACK FOOTER //
// ./src/redux/middleware/ApiFetch.js